// @ts-nocheck
/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ProductTable from "components/ProductTable";
import { Redirect } from "react-router";
// reactstrap components
import {
    Container,
    Card,
    Row,
    Col,
    Button,
    CardBody,
    CardHeader,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";

class ProductList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
        };
    }

    handleOnClick = () => {
        this.setState({ redirect: true });
    };

    render() {
        if (this.state.redirect) {
            return <Redirect push to="/admin/listing" />;
        }
        return (
            <div>
                <Header />
                <Container className="mt--7" fluid>
                    <Card>
                        <CardHeader>
                            <Button
                                color="primary"
                                type="button"
                                onClick={this.handleOnClick}
                            >
                                Add Product
                            </Button>
                        </CardHeader>
                        <ProductTable style={{ maxWidth: "100%" }} />
                    </Card>
                </Container>
            </div>
        );
    }
}

export default ProductList;
